<div class="sidenav">
  <div class="logo-container">
    <button class="logo" (click)="toggleCollapse()">M</button>
    <div class="logo-text" *ngIf="isCollapsed">Menu</div>
  </div>

  <div class="scrollwrap scrollwrap_delayed">
    <ul class="sidenav-nav">
      <li class="sidenav-nav-item" *ngFor="let data of navData">
        <a class="sidenav-nav-link" (click)="handleClick(data)" *ngIf="data.items && data.items.length > 0" [ngClass]="getActiveClass(data)">
          <i class="sidenav-link-icon" [class]="data.icon" data-bs-toggle="tooltip" data-bs-placement="right" title="{{ data.label }}"></i>
          <span class="sidenav-link-text" *ngIf="isCollapsed" data-bs-toggle="tooltip" data-bs-placement="right" title="{{ data.label }}">{{ data.label }}</span>
          <i *ngIf="data.items && isCollapsed" class="menu-collapse-icon" [ngClass]="data.expanded ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
        </a>
        <a class="sidenav-nav-link" *ngIf="!data.items || (data.items && data.items.length === 0)">
          <i class="sidenav-link-icon" [class]="data.icon"></i>
          <span class="sidenav-link-text" *ngIf="isCollapsed">{{ data.label }}</span>
        </a>
        <div *ngIf="isCollapsed && data.items && data.items.length > 0">
          <app-sublevel-menu [data]="data" [collapsed]="isCollapsed" [expanded]="data.expanded"></app-sublevel-menu>
        </div>
      </li>
    </ul>
  </div>
</div>